import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  Nav,
  NavLink,
  Row,
  Col,
  TabContent,
  TabPane,
} from "reactstrap"
import { FormSection, initialize, reduxForm } from "redux-form"
import AccessTab from "./accessTab"
import ConnectCalendarTab from "./connectCalendarTab"
import SetUpTab from "./setUpTab"
import { FORM_NAMES } from "constants/index"
import BottomNavigation from "components/BottomNavigation"
import { SaveButton } from "components/Buttons"
import { connect } from "react-redux"
import {
  createBookingCalendar,
  resetSelectedCalendar,
  updateBookingCalendar,
} from "store/actions"

const CalendarGroup = ({
  handleBack,
  handleSubmit,
  selectedCalendar,
  initializeForm,
  resetSelectedCalendar,
  vendorId,
  userId,
  updateBookingCalendar,
  createBookingCalendar,
  loading,
  setSubTabBreadcrumb,
  allCalendars,
}) => {
  const TABS = {
    SET_UP: 1,
    ACCESS: 2,
    CONNECT_CALENDAR: 3,
  }

  const [activeTab, setActiveTab] = useState(TABS.SET_UP)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  useEffect(() => {
    setSubTabBreadcrumb([
      {
        title: selectedCalendar
          ? "Edit Calendar Group"
          : "Create Calendar Group",
        type: "tab",
        clickHandler: () => {
          setActiveTab(TABS.SET_UP)
        },
      },
      {
        title:
          activeTab === 1
            ? "Set Up"
            : activeTab === 2
            ? "Access"
            : "Connect Calendar",
      },
    ])
  }, [activeTab, selectedCalendar])

  useEffect(() => {
    return () => {
      resetSelectedCalendar()
    }
  }, [])

  useEffect(() => {
    if (selectedCalendar) {
      initializeForm({
        setUp: {
          name: selectedCalendar?.name,
          color: selectedCalendar?.color,
          businessUnit: selectedCalendar?.business_unit_id,
          paidServices: selectedCalendar?.paid_services,
        },
        access: {
          owner: selectedCalendar?.owners?.map(owner => ({
            label: owner?.display_name,
            value: owner?.id,
          })),
          tags: selectedCalendar?.tags?.map(tag => tag?.id),
          shareList: selectedCalendar?.share_users?.map(item => ({
            label: item?.display_name,
            value: item?.id,
          })),
        },
      })
    }
  }, [selectedCalendar])

  const handleSave = data => {
    if (!selectedCalendar) {
      createBookingCalendar({
        access_type: 3,
        bookable: 1,
        business_unit_id: data?.setUp?.businessUnit,
        color: data?.setUp?.color || "rgba(1, 1, 1, 1)",
        name: data?.setUp?.name,
        owner_ids: [],
        paid_services: data?.setUp?.paidServices,
        share_user_ids: [],
        tag_ids: [],
        tags: [],
        type: "2",
        user_id: userId,
        vendor_id: vendorId,
        order: allCalendars?.length + 1,
      })
    } else {
      updateBookingCalendar({
        ...selectedCalendar,
        color: data?.setUp?.color,
        name: data?.setUp?.name,
        business_unit_id: data?.setUp?.businessUnit,
        owner_ids: data?.access?.owner
          ? data?.access?.owner?.map(o => o?.value)
          : [],
        tag_ids: data?.access?.tags ? data?.access?.tags : [],
        access_type:
          data?.access?.tags && data?.access?.tags?.length > 0 ? 2 : 3,
        share_user_ids: data?.access?.shareList
          ? data?.access?.shareList?.map(s => s?.value)
          : [],
        paid_services: data?.setUp?.paidServices,
      })
    }
  }

  return (
    <Card>
      <CardBody className="ms-5">
        <Row className="d-flex justify-content-between">
          <Col xs="auto">
            {selectedCalendar && (
              <h5 className="mt-1">
                Edit Calendar Group: {selectedCalendar?.name}
              </h5>
            )}
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Done"
              color="light"
              onClick={handleBack}
            />
          </Col>
        </Row>
        <Row>
          <Col xs="auto" className="my-3">
            <Nav pills className="flex-column">
              <NavLink
                className={markIfIsActive(TABS.SET_UP)}
                onClick={() => setActiveTab(TABS.SET_UP)}
                style={
                  activeTab === TABS.SET_UP
                    ? {}
                    : { backgroundColor: "#eff2f7" }
                }
              >
                {<span style={{ fontSize: "16px" }}>Set Up</span>}
              </NavLink>
              <NavLink
                className={markIfIsActive(TABS.ACCESS)}
                onClick={() => setActiveTab(TABS.ACCESS)}
                style={
                  activeTab === TABS.ACCESS
                    ? {}
                    : { backgroundColor: "#eff2f7" }
                }
              >
                {<span style={{ fontSize: "16px" }}>Access</span>}
              </NavLink>
              <NavLink
                className={markIfIsActive(TABS.CONNECT_CALENDAR)}
                onClick={() => setActiveTab(TABS.CONNECT_CALENDAR)}
                style={
                  activeTab === TABS.CONNECT_CALENDAR
                    ? {}
                    : { backgroundColor: "#eff2f7" }
                }
              >
                {<span style={{ fontSize: "16px" }}>Connect Calendar</span>}
              </NavLink>
            </Nav>
          </Col>
          <Col>
            <TabContent activeTab={activeTab}>
              <TabPane tabId={TABS.SET_UP}>
                <FormSection name="setUp">
                  <SetUpTab
                    handleNext={() => {
                      setActiveTab(TABS.ACCESS)
                    }}
                    handleSave={handleSubmit(handleSave)}
                    tabIsActive={activeTab === TABS.SET_UP}
                  />
                </FormSection>
              </TabPane>
              <TabPane tabId={TABS.ACCESS}>
                <FormSection name="access">
                  <AccessTab
                    tabIsActive={activeTab === TABS.ACCESS}
                    handleSave={handleSubmit(handleSave)}
                  />
                </FormSection>
                <BottomNavigation
                  handleNext={() => {
                    setActiveTab(TABS.CONNECT_CALENDAR)
                  }}
                  handleBack={() => {
                    setActiveTab(TABS.SET_UP)
                  }}
                  handleSave={handleSubmit(handleSave)}
                  loading={loading}
                  saveButtonDisabled={!selectedCalendar}
                />
              </TabPane>
              <TabPane tabId={TABS.CONNECT_CALENDAR}>
                <ConnectCalendarTab />
                <BottomNavigation
                  handleBack={() => {
                    setActiveTab(TABS.ACCESS)
                  }}
                />
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

const mapStateToProps = state => ({
  selectedCalendar: state.BookingsFeature.selectedCalendar,
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  loading: state.BookingsFeature.loading,
  allCalendars: state.BookingsFeature.allCalendars,
})

const mapDispatchToProps = dispatch => ({
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.CALENDAR_GROUP, values)),
  resetSelectedCalendar: () => dispatch(resetSelectedCalendar()),
  createBookingCalendar: values => dispatch(createBookingCalendar(values)),
  updateBookingCalendar: values => dispatch(updateBookingCalendar(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: FORM_NAMES.CALENDAR_GROUP })(CalendarGroup))
